import { FOOD_ITEM_INPUT_SELECTOR } from 'common/FoodUtils';
import { SpiceLevelOptions } from 'web-common/src/shared/Enums';

export const NOT_SPICY = {
  dataTest: FOOD_ITEM_INPUT_SELECTOR.SPICE_LEVEL.NOT_SPICY,
  value: SpiceLevelOptions.NOT_SPICY,
};

export const MILD = {
  dataTest: FOOD_ITEM_INPUT_SELECTOR.SPICE_LEVEL.MILD,
  value: SpiceLevelOptions.MILD,
};

export const MEDIUM = {
  dataTest: FOOD_ITEM_INPUT_SELECTOR.SPICE_LEVEL.MEDIUM,
  value: SpiceLevelOptions.MEDIUM,
};

export const HOT = {
  dataTest: FOOD_ITEM_INPUT_SELECTOR.SPICE_LEVEL.HOT,
  value: SpiceLevelOptions.HOT,
};

export const SPICE_LEVELS = [
  SpiceLevelOptions.NOT_SPICY,
  SpiceLevelOptions.MILD,
  SpiceLevelOptions.MEDIUM,
  SpiceLevelOptions.HOT,
];

export const SPICE_LEVEL_OPTIONS = [NOT_SPICY, MILD, MEDIUM, HOT];

export const ROW_TEXT = {
  title: 'Spice level',
};
